import { createApp } from "vue";
import { pinia } from "./stores";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import i18n from "./locales/i18n";
import "./styles/index.scss";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { en, zhHans, zhHant } from "vuetify/locale";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    messages: { en, zhHans, zhHant }
  }
});

const app = createApp(App);
app.config.globalProperties.window = window;
app.config.globalProperties.productionTip = false;

app.use(i18n).use(pinia).use(router).use(vuetify).mount("#app");
